<template>
  <div>
    <div
      class="btn btn_lg btn_px-lg border-radius-md fs-18 fw-medium w-100 fs-sm-14 btn_primary btn btn_lg btn_primary"
      @click="showPopup()"
    >
      Заказ в 1 клик
    </div>

    <teleport to="#product-element__popup-container-vue">
      <transition name="fade">
        <div
          class="popup d-flex d-flex_middle d-flex_center d-flex_column"
          v-if="isShow"
        >
          <div class="popup__layout" @click="closePopup()"></div>
          <div
            class="popup__wrap p-16 p-lg-0 scroll scroll_y w-100 active-move-down"
            v-bind:class="{ 'is-active': isAnimate }"
          >
            <div
              class="popup__block popup__block_xs bg-white border-radius-xl p-24 p-md-16 mx-auto"
            >
              <div class="grid-row d-flex_middle d-flex_reverse">
                <div class="grid-col">
                  <div
                    class="btn color-gray hover-color-dark"
                    @click="closePopup()"
                  >
                    <Icon iconName="icon-close" className="icon-24" />
                  </div>
                </div>

                <div class="grid-col grid-col_full">
                  <div class="fw-medium fs-20 fs-lg-16 pl-40 text-center">
                    Покупка в один клик
                  </div>
                </div>
              </div>
              <div class="oneClickForm">
                <div class="mt-20 text-center">
                  Оставьте свой номер телефона. Вам перезвонит наш специалист и
                  уточнит детали заказа.
                </div>
                <form @submit.prevent="sendFeedback()">
                  <div class="mt-24">
                    <!-- Плавающий label ставим четко за инпутом, если не получается - надо скриптом будет  -->
                    <div class="form-group form-group_floating">
                      <input
                        id="phone"
                        type="tel"
                        class="form-field"
                        :class="{
                          'is-error': bindedObject.completed === false,
                        }"
                        placeholder="Ваш номер телефона"
                        v-maska:[bindedObject]
                        v-model="maskedValue"
                        :required="true"
                      />
                      <label for="phone" class="form-group__label"
                        >Ваш номер телефона</label
                      >
                    </div>
                    <div
                      v-if="bindedObject.completed === false"
                      class="color-negative fs-14 mt-4"
                    >
                      Введите корректный номер телефона
                    </div>
                  </div>

                  <div class="mt-16">
                    <button
                      class="button button_lg button_primary fs-14 fs-md-12 fw-medium text-uppercase w-100"
                      type="submit"
                      :disabled="bindedObject.completed === false"
                    >
                      Отправить
                    </button>
                  </div>
                </form>
                <div class="mt-16 fs-14 text-center">
                  Нажимая на кнопку, вы подтверждаете своё совершеннолетие,
                  соглашаетесь на обработку персональных данных в соответствии с
                  <a target="_blank" href="/offer/">Соглашением</a> и
                  ознакомлен(а) с
                  <a target="_blank" href="/privacy_agreement/"
                    >политикой конфиденциальности</a
                  >
                  ООО «НИКАМЕД»
                </div>
              </div>
              <div class="oneClickThankYou g-hidden">
                <div
                  class="fw-bold fs-20 fs-lg-16 pl-40 text-center color-tertiary"
                >
                  Спасибо зазаказ
                </div>
                <div class="centred">Мы вам перезвоним в течение 30 минут.</div>
                <div class="flex-justify">
                  <svg
                    class="b-popup-icon"
                    width="96"
                    height="96"
                    viewBox="0 0 96 96"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_677_22682)">
                      <path
                        d="M32 0C18.7452 0 8 10.7452 8 24V41.6C8.007 47.7826 13.0174 52.793 19.2 52.8H20.8V49.6H19.2C14.784 49.5948 11.2052 46.016 11.2 41.6V24C11.2 12.5124 20.5124 3.2 32 3.2C43.4876 3.2 52.8 12.5124 52.8 24V41.6C52.7948 46.016 49.216 49.5948 44.8 49.6H43.2V52.8H44.8C50.9826 52.793 55.993 47.7826 56 41.6V24C56 10.7452 45.2548 0 32 0Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M13.1856 75.4064L14.3551 73.5649L11.6528 71.8496L10.4832 73.6928C6.94575 79.2673 7.20836 86.4448 11.144 91.7456V96.0001H14.344V91.2001C14.3442 90.8366 14.2206 90.4838 13.9936 90.2C10.592 85.9477 10.2674 80.0041 13.1856 75.4064Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M87.9997 0H67.1997C62.7837 0.00519999 59.205 3.584 59.1997 8V24C59.205 28.416 62.7837 31.9948 67.1997 32H70.3998V38.4C70.3995 39.047 70.7892 39.6306 71.3869 39.8784C71.5812 39.9594 71.7894 40.0006 71.9997 40C72.4242 40 72.831 39.8312 73.131 39.5312L80.6622 32H87.9997C92.4157 31.9948 95.9946 28.416 95.9997 24V8C95.9946 3.584 92.4157 0.00519999 87.9997 0ZM92.7997 24C92.7997 26.651 90.6507 28.8 87.9997 28.8H79.9998C79.5753 28.8 79.1685 28.9688 78.8685 29.2688L73.5997 34.5376V30.4C73.5997 29.5164 72.8833 28.8 71.9997 28.8H67.1997C64.5487 28.8 62.3997 26.651 62.3997 24V8C62.3997 5.349 64.5487 3.2 67.1997 3.2H87.9997C90.6507 3.2 92.7997 5.349 92.7997 8V24Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M78.4002 8H67.2002V11.2H78.4002V8Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M88.0001 8H81.6001V11.2H88.0001V8Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M88.0002 14.3999H67.2002V17.5999H88.0002V14.3999Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M78.4002 20.8H67.2002V24H78.4002V20.8Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M53.5164 73.6928L52.3469 71.8496L49.6445 73.5649L50.814 75.4081C53.7324 80.005 53.4079 85.9483 50.0061 90.2C49.7791 90.4838 49.6555 90.8366 49.6557 91.2001V96.0001H52.8557V91.7456C56.7912 86.4448 57.0539 79.2673 53.5164 73.6928Z"
                        fill="#4FBAC2"
                      />
                      <path
                        d="M94.4 54.3999H80C73.9968 54.407 69.0668 59.1458 68.8224 65.144L64 73.8255V67.1999C63.993 61.0173 58.9826 56.0069 52.8 56H46.952L46.9088 55.9664L46.88 56H43.2C41.4326 56 40 54.5673 40 52.7999V49.0352C44.9438 46.1807 47.9924 40.9085 48 35.1999V22.4C47.9976 19.7489 47.338 17.1399 46.08 14.8064C45.677 14.0639 44.7662 13.7625 44 14.1183L16.9184 26.8607C16.3576 27.1247 15.9998 27.689 16 28.3088V35.1999C16.0076 40.9085 19.0562 46.1807 24 49.0352V52.7999C24 54.5673 22.5674 56 20.8 56H11.2C5.0174 56.0069 0.007 61.0173 0 67.1999V95.9999H3.2V67.1999C3.2052 62.7839 6.784 59.2052 11.2 59.1999H16.2912L30.6992 79.3311C30.9952 79.745 31.4704 79.9931 31.9792 80H32C32.5036 80 32.9778 79.7627 33.28 79.3599L48.48 59.1999H52.8C57.216 59.2052 60.7948 62.7839 60.8 67.1999V80C60.8008 80.8836 61.5178 81.5993 62.4014 81.5985C62.9818 81.5979 63.5164 81.2834 63.7984 80.7759L71.3408 67.1999H80.5136L64.9136 95.9999H68.5536L84.16 67.1999H84.8C90.9826 67.193 95.993 62.1825 96 56C96 55.1163 95.2836 54.3999 94.4 54.3999ZM19.2 35.1999V29.3247L43.9056 17.6991C44.4966 19.196 44.8 20.7908 44.8 22.4V35.1999C44.8 42.2691 39.0692 47.9999 32 47.9999C24.9308 47.9999 19.2 42.2691 19.2 35.1999ZM32.0336 75.6992L27.096 68.7999H37.2336L32.0336 75.6992ZM39.6544 65.6H24.8L20.2192 59.1999H20.8C24.3346 59.1999 27.2 56.3345 27.2 52.7999V50.4623C30.3244 51.4457 33.6756 51.4457 36.8 50.4623V52.7999C36.8 56.3345 39.6654 59.1999 43.2 59.1999H44.48L39.6544 65.6ZM84.8 63.9999H72.16C72.925 60.2774 76.1996 57.6041 80 57.5999H92.64C91.875 61.3226 88.6004 63.9957 84.8 63.9999Z"
                        fill="#4FBAC2"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_677_22682">
                        <rect width="96" height="96" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!-- /popup__wrap -->
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { vMaska } from "maska";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { sendRequest } from "@/pages/product_card/api/product.api";
export default {
  name: "PopupOneClick",
  components: {
    Icon,
  },
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  data() {
    return {
      isShow: false,
      isAnimate: false,
      maskedValue: "",
      bindedObject: {
        mask: "+7 (T##) ###-##-##",
        tokens: { T: { pattern: /[9]/ } },
      },
    };
  },
  directives: { maska: vMaska },
  methods: {
    showPopup() {
      if (!this.store.isAllParamSelected()) {
        document.dispatchEvent(new Event("check-selected-params"));
        document.dispatchEvent(new Event("show-error-no-selected"));
        return false;
      }

      this.isShow = true;
      setTimeout(() => {
        this.isAnimate = true;
        document.querySelector(".oneClickForm").classList.remove("g-hidden");
        document.getElementById("phone").value = "";
        document.querySelector(".oneClickThankYou").classList.add("g-hidden");
      }, 2);
    },
    closePopup() {
      this.isAnimate = false;
      setTimeout(() => {
        this.isShow = false;
      }, 150);
    },
    sendFeedback() {
      this.toggleOneClick();
      sendRequest(
        this.store.getSelectedProduct.name,
        this.store.getSelectedOffer?.kod_torgovogo_predlozheniya ??
          this.store.getSelectedProduct?.productCode,
        document.getElementById("phone").value,
        44
      );
    },
    toggleOneClick() {
      document.querySelector(".oneClickForm").classList.add("g-hidden");
      document.querySelector(".oneClickThankYou").classList.remove("g-hidden");
    },
  },
};
</script>

<!-- <style lang="scss">
@import "./popup.scss";
</style> -->
